import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

const linkStyle = {
  fontFamily: "Montserrat, sans-serif",
  fontSize: 15,
  fontWeight: 500,
  color: "#7BB5B1",
  textDecoration: "none",
};

const NotFound = () => (
  <div data-testid="notfound-root" style={{ background: "#081412", minHeight: "100vh" }}>
    <Header />
    <main
      style={{
        maxWidth: 720,
        margin: "0 auto",
        padding: "180px 24px 120px",
        textAlign: "center",
      }}
    >
      <h1
        style={{
          fontFamily: "Montserrat, sans-serif",
          fontWeight: 300,
          fontSize: "clamp(34px, 5vw, 56px)",
          letterSpacing: "-0.025em",
          color: "#FFFFFF",
          margin: 0,
        }}
      >
        This route doesn't resolve.
      </h1>
      <p
        style={{
          fontFamily: "system-ui, -apple-system, sans-serif",
          fontSize: 17,
          fontWeight: 300,
          lineHeight: 1.6,
          color: "rgba(255,255,255,0.55)",
          margin: "20px 0 36px",
        }}
      >
        The page you're looking for was never deployed, or it's since been retired. Here's where most people are headed instead.
      </p>
      <div style={{ display: "flex", gap: 28, justifyContent: "center", flexWrap: "wrap" }}>
        <Link to="/portfolio" style={linkStyle}>See our work</Link>
        <a href="/#services" style={linkStyle}>Services</a>
        <a href="/#contact" style={linkStyle}>Contact us</a>
      </div>
    </main>
    <Footer />
  </div>
);

export default NotFound;
